import { getRTFInformation } from "@bond-london/graphcms-rich-text";
import classNames from "classnames";
import React from "react";
import { RTF } from "./RTF";

export const ContactInformation: React.FC<{
  title?: string;
  className?: string;
  information: Queries.ContactInformationFragment;
}> = ({ title, information, className = "" }) => {
  const addressContent = getRTFInformation(information?.address);
  const otherContent = getRTFInformation(information?.otherInformation);
  return (
    <div className={classNames(className)}>
      {title && (
        <h3 className={classNames("h7", "text-lazer", "mb-10px")}>{title}</h3>
      )}
      {addressContent && (
        <RTF content={addressContent} className="rich-text text-cotton" />
      )}
      {otherContent && (
        <RTF content={otherContent} className="mt-30px text-cotton" />
      )}
    </div>
  );
};
